/**
 * Strips all non-digit characters from a formatted phone string.
 * "(346) 567-6900" -> "3465676900"
 */
export function stripPhoneFormatting(formatted: string): string {
    return formatted.replace(/\D/g, "");
}

/**
 * Format a phone string for display: "(346)-567-6900"
 */
export function formatPhoneForDisplay(phone: string): string {
    const digits = stripPhoneFormatting(phone);
    if (digits.length !== 10) return phone; // fallback
    return `(${digits.slice(0, 3)})-${digits.slice(3, 6)}-${digits.slice(6)}`;
}
